import {
  AssetRoutineState,
  FeatureName,
  RoutineState,
  useIsFeatureEnabled,
  WorkflowQuestionConfig,
  WorkspaceAsset,
} from '@gripp/shared-logic';
import { View } from 'react-native';
import { Text } from 'react-native-paper';
import { tokens } from '../../../crop-circle/tokens';
import { RenderMediaSourcExecutionForm } from '../../components/renderMediaSource';
import { RoutineQuestionModules } from '../questions/routineQuestionModules';
import { styles, stylesCropCircle } from './styles';

type WorkflowExecutionQuestionProps = {
  config: WorkflowQuestionConfig;
  questionIndex: number;
  responseIndex: number;
  workspaceAsset: WorkspaceAsset;
  toggleProcessing?: (value: boolean) => void;
  currentState: AssetRoutineState<RoutineState> | undefined;
  isIssueEditRoutine?: boolean;
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const WorkflowExecutionQuestionOld = (
  props: WorkflowExecutionQuestionProps
) => {
  const ExecutionForm = RoutineQuestionModules[props.config.type].executionForm;

  return (
    <View style={styles.questionContainer}>
      <View style={styles.instructionsContainer}>
        <Text style={styles.instructionsText}>
          {props.questionIndex + 1}. {props.config.instructions}
        </Text>
      </View>

      {props.config?.media ? (
        <RenderMediaSourcExecutionForm value={props.config?.media} />
      ) : null}
      <ExecutionForm
        config={props.config}
        responseIndex={props.responseIndex}
        workspaceAsset={props.workspaceAsset}
        toggleProcessing={props.toggleProcessing}
        currentState={props.currentState}
        isIssueEditRoutine={props.isIssueEditRoutine}
      />
    </View>
  );
};

// TODO: Crop Circle Redesign | Remove to WorkflowExecutionQuestionBase after feature is fully rolled out
const WorkflowExecutionQuestionBase = (
  props: WorkflowExecutionQuestionProps
) => {
  const ExecutionForm = RoutineQuestionModules[props.config.type].executionForm;

  return (
    <View style={stylesCropCircle.questionContainer}>
      <View style={stylesCropCircle.questionTitleContainer}>
        <Text style={tokens.typography.label.largeEmphasised}>
          {props.questionIndex + 1}. {props.config.instructions}
        </Text>
      </View>

      {props.config?.media ? (
        <RenderMediaSourcExecutionForm value={props.config?.media} />
      ) : null}
      <ExecutionForm
        config={props.config}
        responseIndex={props.responseIndex}
        workspaceAsset={props.workspaceAsset}
        toggleProcessing={props.toggleProcessing}
        currentState={props.currentState}
        isIssueEditRoutine={props.isIssueEditRoutine}
      />
    </View>
  );
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
export const WorkflowExecutionQuestion = (
  props: WorkflowExecutionQuestionProps
) => {
  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  if (!isCropCircleRedesignEnabled) {
    return <WorkflowExecutionQuestionOld {...props} />;
  }

  // TODO: Crop Circle Redesign | Remove to WorkflowExecutionQuestionBase after feature is fully rolled out
  return <WorkflowExecutionQuestionBase {...props} />;
};
